// @flow
import {
	execute,
	CursorSpinner,
} from 'fg-frontend';
import closeEsp from 'fg-frontend/webActions/closeEsp';
import goBack from 'fg-frontend/webActions/goBack';
import scrollToHref from 'fg-frontend/webActions/scrollToHref';
import confirmPopup from 'fg-frontend/webActions/confirmPopup';
import passwordStrength from 'fg-frontend/webActions/passwordStrength';
import menuToggle from './webActions/menuToggle';
import smoothScroll from './webActions/smoothScroll';

import configureEshopActions from './configureEshopActions';

export default (action) => {
	switch (action) {
		case 'hsExpand':
			return (props, e) => {
				e.preventDefault();
				CursorSpinner.pushToQueue('importHsExpand');
				import('./webActions/hsExpand').then((hsExpand) => {
					CursorSpinner.removeFromQueue('importHsExpand');
					hsExpand.default(props, e);
				});
			};
		case 'execute':
			return execute;
		case 'closeEsp':
			return closeEsp;
		case 'goBack':
			return goBack;
		case 'scrollToHref':
			return scrollToHref;
		case 'passwordStrength':
			return passwordStrength;
		case 'confirmPopup':
			return confirmPopup;
    case 'menuToggle':
      return menuToggle;
    case 'smoothScroll':
      return smoothScroll;
		default:
			const eshopAction = configureEshopActions(action);
			if (eshopAction) {
				return eshopAction;
			}
			else {
				console.log(`Unknown action`);
				return null;
			}
	}
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWebActions.js